import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons'; // Import the social media icons

function Contact() { // Capitalize the component name
  return (
    <section id='contact' className='contact'>
      <div className='container'>
        <div className='heading-sec px-5 mb-5 text-center m-auto'>
          <div className='strip-heading'>Contact</div>
          <h2 className='h3-heading text-dark'>Get in Touch</h2>
          <div className='h6-heading mb-3'>Reach out to us today and let’s discuss your needs.</div>
        </div>
        <div className='col-lg-5 col-md-8 col-12 m-auto contact-options'>
          <div className='rounded-5 mb-3 bg-light p-3 d-flex align-items-center justify-content-center fs-6 box-shadow'>
            <FontAwesomeIcon className='me-3' icon={faPhone} />
            <a href='callto:+91-0123456789' className='text-dark'>+91-0123456789</a>, &nbsp; 
            <a href='callto:+91-0123456789' className='text-dark'>+91-0123456789</a>
          </div>
          <div className='rounded-5 mb-3 bg-light p-3 d-flex align-items-center justify-content-center fs-6 box-shadow'>
            <a href='mailto:example@example.com' className='text-dark'>
              <FontAwesomeIcon className='me-3' icon={faEnvelope} />example@example.com
            </a>
          </div>
        </div>
        <div className='rounded-5 mb-3 bg-light p-4 col-lg-5 col-md-8 col-12 m-auto text-center box-shadow'>
          <p className='text-dark fs-6 mb-3 fw-500'>Choose a plan that fits for your business</p>
          <a href='#' className='btn btn-primary rounded-5'>Get Started</a>
        </div>
        <div className='social-media d-flex justify-content-center align-items-center gap-3 mt-5'>
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className='rounded-5 text-dark bg-light'>
            <FontAwesomeIcon icon={faFacebook} />
          </a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className='rounded-5 text-dark bg-light'>
            <FontAwesomeIcon icon={faTwitter} />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className='rounded-5 text-dark bg-light'>
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;
